import React, { useState } from "react";
import "../styles/SettingsPage.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import InternalUsersPage from "./InternalUsersPage"; // ✅ Ajout de l'import
import SystemSettings from "./SystemSettings";
import BulkOperations from "./BulkOperations";

export default function SettingsPage() {
  const [activeTab, setActiveTab] = useState("password");
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [showPassword3, setShowPassword3] = useState(false);

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    setError(null);

    if (!currentPassword || !newPassword || !confirmPassword) {
      setError("Veuillez remplir tous les champs.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Les nouveaux mots de passe ne correspondent pas.");
      return;
    }

    try {
      const response = await fetch("/api/auth/change-password", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          currentPassword,
          newPassword,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Erreur lors du changement de mot de passe.");
      }

      navigate("/parametres/success"); // ✅ redirection
    } catch (err) {
      setError(err.message);
    }
  };

  const renderPasswordForm = () => (
    <div className="settings-content">
      <h3>Mot de passe</h3>
      <p className="intro">
        Pour garantir la sécurité de votre compte, vous pouvez mettre à jour votre mot de passe
      </p>
      <form className="password-form" onSubmit={handleSubmit}>
        <div className="input-group">
          <label>Mot de passe actuel</label>
          <div className="input-wrapper">
            <input
              type={showPassword1 ? "text" : "password"}
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
            />
            <span onClick={() => setShowPassword1(!showPassword1)}>
              {showPassword1 ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
        </div>

        <div className="input-group">
          <label>Nouveau mot de passe</label>
          <div className="input-wrapper">
            <input
              type={showPassword2 ? "text" : "password"}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
            <span onClick={() => setShowPassword2(!showPassword2)}>
              {showPassword2 ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
        </div>

        <div className="input-group">
          <label>Confirmer mot de passe</label>
          <div className="input-wrapper">
            <input
              type={showPassword3 ? "text" : "password"}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            <span onClick={() => setShowPassword3(!showPassword3)}>
              {showPassword3 ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
        </div>

        <div className="button-group">
          {error && <div className="error-message">{error}</div>}
          {message && <div className="success-message">{message}</div>}
          <button type="button" className="btn-cancel">Annuler</button>
          <button type="submit" className="btn-save">Enregistrer</button>
        </div>
      </form>
    </div>
  );

  return (
    <div className="settings-container">
      <aside className="settings-sidebar">
        <h2>Paramètre</h2>
        <nav>
          <ul>
            <li
              className={activeTab === "password" ? "active" : ""}
              onClick={() => setActiveTab("password")}
            >
              Mot de passe
            </li>
            <li
              className={activeTab === "internal" ? "active" : ""}
              onClick={() => setActiveTab("internal")}
            >
              Utilisateur interne
            </li>
            <li
              className={activeTab === "system" ? "active" : ""}
              onClick={() => setActiveTab("system")}
            >
              Paramètres système
            </li>
            <li
              className={activeTab === "bulk" ? "active" : ""}
              onClick={() => setActiveTab("bulk")}
            >
              Opérations en lot
            </li>
          </ul>
        </nav>
      </aside>

      <div className="settings-main">
        {activeTab === "password" && renderPasswordForm()}
        {activeTab === "internal" && <InternalUsersPage />}
        {activeTab === "system" && <SystemSettings />}
        {activeTab === "bulk" && <BulkOperations />}
      </div>
    </div>
  );
}
